
<script>
  import { getContext } from 'svelte';

  const { data, xGet, yGet, xScale, yScale } = getContext('LayerCake');

  export let formatLabel;


  let hidden = false;

  function update(ddd) {
    if (typeof window !== 'undefined') {
      hidden = true;
      setTimeout(()=>{hidden=false;}, 800);
    }
    const vals = ddd.map($yGet);
    const minVal = Math.min(...vals);
    const maxVal = Math.max(...vals);
    let iMin = vals.indexOf(minVal);
    if (iMin < vals.length - 1 && vals[iMin + 1] === minVal) iMin += 1;
    let iMax = vals.lastIndexOf(maxVal);
    if (iMax > 0 && vals[iMax - 1] === maxVal) iMax -= 1;
    const min = ddd[iMin];
    const max = ddd[iMax];
    return [min, max];
  }



  $: dat = update($data);

  

</script>

  {#each dat as d,i}

    <div class="minmax" class:min={i === 0} class:max={i===1} class:hidden={hidden} style="
      left:{$xGet(d) + ($xScale.bandwidth ? $xScale.bandwidth() / 2 : 0) + '%'};
      top:{$yGet(d) + ($yScale.bandwidth ? $yScale.bandwidth() / 2 : 0) + '%'};
    ">
      <div class="circle"></div>
      <div class="label">{formatLabel(d)}</div>
    </div>

  {/each}

<style>
  .minmax {
    position: absolute;
    pointer-events: none;
    opacity: 1;
    transition: opacity 1s;
  }

  .hidden {
    opacity: 0;
    transition: none;
  }

  .circle {
    width: 8px;
    height: 8px;
    position: absolute;
    left: -4px;
    top: -4px;
    background: #1f1f1f;
    border-radius: 50%;
  }

  .label {
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
  }

  .max .label {
    transform: translate(-50%, 6px);
  }

  .min .label {
    transform: translate(-50%, calc(-100% - 6px));
  }
</style>

